module.exports = __webpack_public_path__ + "img/step3.9a38d7c4.png";